const STAKEHOLDER_TYPE = {
  CPO: 'cpo',
}

module.exports = {
  STAKEHOLDER_TYPE,
}
